import { ref } from "vue"
import { useCasinoLobbyStore } from "../store/casinoLobby.store"

export function useCasinoFilters() {
  const casinoLobbyStore = useCasinoLobbyStore()
  const filters = ref({
    search: "",
    providers: [],
    sort: "",
  })

  function onSearch(value: string) {
    filters.value.search = value
    casinoLobbyStore.setSearch(value)
  }

  function onSort(value: string) {
    filters.value.sort = value
  }

  function onProviders(value: string[]) {
    filters.value.providers = value
  }

  return {
    filters,
    onSearch,
    onSort,
    onProviders,
  }
}
